// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PXfTy","colBig":"styles_colBig__39FbX","colSmall":"styles_colSmall__3iHPu","shopifyNameWrapper":"styles_shopifyNameWrapper__egeap"};